import { Calendar, formatDate } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from "@fullcalendar/list";

export default function TeamCalendar(today) {
  let teamEl = document.querySelector("#calendar.team");
  if (null == teamEl) return;

  let team_calendar = new Calendar(teamEl, {
    plugins: [listPlugin, dayGridPlugin],
    headerToolbar: {
      left: "prev,next today",
      center: "title",
      right: "listMonth dayGridMonth",
    },
    height: "auto",
    initialView: "listMonth",
    initialDate: today,
    navLinks: true, // can click day/week names to navigate views
    editable: true,
    dayMaxEvents: true, // allow "more" link when too many events
    listDayFormat: {
      weekday: "long",
      month: "short",
      day: "2-digit",
    },
    listDaySideFormat: false,
    eventClassNames: function (info) {
      let classes = [info.event.extendedProps.home_or_away];
      if (info.event.extendedProps.orig_start) classes.push("rescheduled");
      return classes;
    },
    eventContent: function (info) {
      // Customize the event HTML here
      return {
        html:
          '<div class="fc-content">' +
          (info.timeText ? info.timeText + "<br />" : "") +
          (info.event.extendedProps.cancelled ? "Cancelled <s>" : "") +
          info.event.title +
          "<p>" +
          info.event.extendedProps.home_or_away +
          "</p>" +
          (info.event.extendedProps.orig_start
            ? "<p>" + info.event.extendedProps.orig_start + "</p>"
            : "") +
          (info.event.extendedProps.cancelled ? "</s>" : "") +
          "</div>",
      };
    },
    events: renbrook.schedule,
  });

  team_calendar.render();
}
